export const RELEVANCE_SCORE_OPTIONS = [
  {
    id: '1',
    label: '1.0',
    value: '1.0',
    Suffix: 'Highest Relevance',
  },
  {
    id: '2',
    label: '0.9',
    value: '0.9',
  },
  {
    id: '3',
    label: '0.8',
    value: '0.8',
  },
  {
    id: '4',
    label: '0.7',
    value: '0.7',
  },
  {
    id: '5',
    label: '0.6',
    value: '0.6',
  },
  {
    id: '6',
    label: '0.5',
    value: '0.5',
  },
  {
    id: '7',
    label: '0.4',
    value: '0.4',
  },
  {
    id: '8',
    label: '0.3',
    value: '0.3',
  },
  {
    id: '9',
    label: '0.2',
    value: '0.2',
  },
  {
    id: '10',
    label: '0.1',
    value: '0.1',
  },
  {
    id: '11',
    label: '0.0',
    value: '0',
    Suffix: 'Lowest Relevance',
  },
];

enum InterruptionLevel {
  PASSIVE = 'Passive',
  ACTIVE = 'Active',
  TIME_SENSITIVE = 'TimeSensitive',
  CRITICAL = 'Critical',
}

export const IOS_INTERRUPTION_LEVELS = [
  {
    id: 1,
    label: 'Passive',
    value: InterruptionLevel.PASSIVE,
    subtext:
      'Delivers the notification silently to the Notification Center. Never plays a sound/vibration or lights up the screen.',
  },
  {
    id: 2,
    label: 'Active (Default)',
    value: InterruptionLevel.ACTIVE,
    subtext:
      'Plays a sound/vibration and lights up the screen, per device settings—unless blocked by a Focus or scheduled delivery.',
  },
  {
    id: 3,
    label: 'Time Sensitive',
    value: InterruptionLevel.TIME_SENSITIVE,
    subtext:
      'Plays a sound/vibration and lights up the screen, per device settings. Breaks through a Focus or scheduled delivery, unless the user has blocked your app from doing so.',
  },
  {
    id: 4,
    label: 'Critical',
    value: InterruptionLevel.CRITICAL,
    subtext:
      'Use only for urgent information about personal health or public safety. Plays a sound/vibration and lights up the screen, regardless of device settings. Always breaks through a Focus or scheduled delivery.',
    disabledSubtext:
      'Use only for urgent information about personal health or public safety. Requires a special entitlement from Apple. To enable this, talk to your Iterable customer success manager.',
  },
];

export const SETTINGS_DISPLAY_CONTENT = {
  addRawButton: 'Add raw data',
  removeRawButton: 'Remove raw data',
  header: 'Settings',
  placeholder: 'Select an interruption level...',
  handlebarsRestrictionText: 'Save and preview for accurate character count.',
  snippetToolTip: 'Insert snippet',
  android: 'Android',
  ios: 'iOS',
  sectionHeaders: {
    sendingInformation: 'Sending Information',
    content: 'Content',
    behavior: 'Behavior',
  },
  unsetOptions: 'None',
  unsetText: 'Not set',
  iOSTooltip:
    'This feature requires iOS 15 or higher. It does not affect users on iOS 14 and lower.',
  messageType: {
    labelText: 'Message type',
    helpText:
      'Determines unsubscribe eligibility. Visit Settings > Message Channels and Types to manage and add message types.',
  },
  interruptionLevel: {
    labelText: 'Interruption level',
    restriction: 'iOS 15+',
    helpText:
      'iOS settings help determine when and how to alert a user about the arrival of a push notification.',
    helpLink: {
      text: 'Learn more',
      link: 'https://support.iterable.com/hc/articles/360044425971',
    },
  },
  relevanceScore: {
    labelText: 'Relevance score',
    placeholder: 'Select or enter a value between 0 and 1.0',
    restriction: 'iOS 15+',
    helpText:
      'iOS features the push notification with the highest relevance score when including your app in a notification summary.',
    helpLink: {
      text: 'Learn more',
      link: 'https://support.iterable.com/hc/articles/360044425971',
    },
  },
  badgeCount: {
    labelText: 'Badge count',
    restriction: 'iOS',
    helpText: 'Use a number or handelbars logic.',
    helpLink: {
      text: 'Learn more',
      link: 'https://support.iterable.com/hc/en-us/articles/360044425971',
    },
  },
  wakeUp: {
    labelText: 'Wake up',
    restriction: 'iOS',
    helpText:
      'When this push notification arrives, wake its app in the background to check for new content.',
  },
  title: {
    labelText: 'Title',
  },
  body: {
    labelText: 'Body',
  },
  mediaURL: {
    helpTextAndroid: 'Recommended aspect ratios is 2:1.',
    helpTextiOS: 'Recommended aspect ratios is 1:1.',
    labelText: 'Media URL',
    placeholder: 'https://placekitten.com/300/200',
  },
  dataFeeds: {
    labelText: 'Data feeds',
    helpText: 'Connect data feeds for dynamic template creation.',
  },
  openAction: {
    labelText: 'Open action',
    openAppLabel: 'Open app',
    openUrlLabel: 'Open URL',
    customActionLabel: 'Custom action',
    openApp: 'openApp',
    openUrl: 'openUrl',
    customAction: 'customAction',
    placeholder: 'https://placeholder.com',
    helpText: {
      url: 'Typically a deeplink URL.',
      custom: 'Custom action handler defined in the mobile app.',
    },
  },
  actionButtons: {
    labelText: 'Action buttons',
    buttonText: 'Add action button',
    defaultButtonTitle: 'New button',
    ids: {
      radioOpenAppId: 'radio-action-open-app',
      radioTrackOnlyId: 'radio-action-track-only',
      radioOpenUrlId: 'radio-action-open-url',
      radioCustomActionId: 'radio-action-custom',
      inputFieldOpenUrlId: 'input-open-url',
      inputFieldCustomActionId: 'input-custom-action',
      inputFieldIdentifierId: 'identifier-input-text',
      inputFieldTitleId: 'submit-button-input-text',
      inputFieldPlaceholderId: 'placeholder-input-text',
      inputTextTitleId: 'edit-action-button-title',
    },
    labels: {
      radioOpenAppLabel: 'Open app',
      radioTrackOnlyLabel: 'Track only',
      radioOpenUrlLabel: 'Open URL',
      radioCustomActionLabel: 'Custom action',
      checkboxOpenAppLabel: 'Open app',
    },
    helpTexts: {
      radioTrackOnlyHelpText:
        'This action can be used to track push opens in the background without opening the app.',
      inputFieldHelpText: 'Typically a deeplink URL.',
    },
    placeholders: {
      inputFieldUrlPlaceholder: 'https://www.example.com',
      inputFieldIdentifierPlaceholder: 'newButton',
      inputFieldTitlePlaceholder: 'Send',
      inputFieldPlaceholder: 'Placeholder',
    },
  },
  deepLink: {
    helpText: 'Deep links were added via API. This field is independent of the Open action.',
    labelText: 'Deep link',
    placeholder: 'https://placeholder.com',
  },
  customSound: {
    labelText: 'Custom sound',
    placeholder: '/path/to/customSound.aiff',
  },
  rawData: {
    labelText: 'Raw data (JSON)',
    buttonText: 'Add raw data',
  },
  deliverSilently: {
    checkboxLabel:
      'A silent push is not shown on the device but can be used for changing the badge count, requesting the device to pull additional data from the server or even hydrating content.',
    labelText: 'Deliver silently',
    helpLink: {
      text: 'Learn more',
      link: 'https://support.iterable.com/hc/articles/360044425971#deliver-silently',
    },
    restriction:
      'These cannot be used with Silent Push (Disable Silent Push to trigger a normal Push Notification).',
    silenced: 'Silenced',
  },
};

export const PREVIEWER_CONTENT = {
  emptyMessage: 'To preview your push message, add title and body content in the Settings area',
  silentPushEnabledMessage: "Can't preview silent pushes",
};

export enum MAX_CHAR_LIMIT {
  android = 45,
  ios = 150,
}

export const TEMPLATE_EDITOR_PUSH_PREVIEW_PANE_ID = 'template-editor-push-preview';
export const TEMPLATE_EDITOR_PUSH_PREVIEW_REFRESH_BUTTON =
  'template-editor-push-preview-refresh-button';
export const TEMPLATE_EDITOR_PUSH_PREVIEW_FOOTER = 'template-editor-push-preview-footer';
export const TEMPLATE_EDITOR_PUSH_PREVIEW_TYPE_SELECTOR =
  'template-editor-push-preview-type-selector';
export const TEMPLATE_EDITOR_PUSH_PREVIEW_DATA_MESSAGE =
  'template-editor-push-preview-data-message';
export const TEMPLATE_EDITOR_PUSH_PREVIEW_CHAR_COUNT = 'template-editor-push-preview-char-count';
export const TEMPLATE_EDITOR_PUSH_PREVIEW_SEG_COUNT = 'template-editor-push-preview-seg-count';
export const TEMPLATE_EDITOR_PUSH_PREVIEW_SEGMENTED_CONTROL =
  'template-editor-push-preview-segmented-control';
